import { render, staticRenderFns } from "./warn_level.vue?vue&type=template&id=936195c6&"
import script from "./warn_level.vue?vue&type=script&lang=js&"
export * from "./warn_level.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports